import { Components, Theme } from "@mui/material";
export const muiImageListTheme = (
    theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiImageList"> => ({
    MuiImageList: {},
});
